import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { useRouter } from "expo-router";

import BackButton from "@/Components/Headers/Components/BackButton";

function UserNotificationsHeader(): React.JSX.Element {
  const router = useRouter();

  const customOnPress = (): void => {
    router.push("/(main)/account/home");
  };

  return (
    <SafeAreaView style={styles.safeArea} edges={["top"]}>
      <View style={styles.container}>
        <View style={styles.sideContainer}>
          <BackButton onPress={customOnPress} />
        </View>
        <View style={styles.titleContainer}>
          <Text style={styles.text}>Notifications</Text>
        </View>
        <View style={styles.sideContainer} />
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flexDirection: "row",
    paddingHorizontal: 15,
    paddingVertical: 10,
  },
  safeArea: {
    backgroundColor: "#fff",
  },
  sideContainer: {
    flex: 1,
  },
  titleContainer: {
    alignItems: "center",
  },
  text: {
    fontSize: 20,
  },
});

export default UserNotificationsHeader;
